import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import * as IMAGES from '../../Images';
import { useState } from 'react';
import Fade from 'react-reveal/Fade';
import { header, joinUsBtn, oyoLogoStyle } from '../../partnerStyles';
import view, { formView, oyoFormView } from '../../Enums';
import { Event } from '../../Modules/LandingPageNew/Tracking/Track';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { earningPotentialEnabled, selfOnboardingEnabled, hmsSelfOnboardingEnabled } from '../../config/countryConfig';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import { guc }  from '../../services/Localisation';
import pages, { getRouteForPage } from '../../PageEnums';
import OYO360Logo from '../../resources/vectors/OYO360Logo';

const Header = props => {
  let gucl = props.guc;

  let joinUsBtn_style = {
    ...joinUsBtn,
    border: '0',
    boxShadow: '0 4px 8px 0 rgba(26, 182, 79, 0.2)',
    right: '0px',
    fontSize: '13px'
  };

  let headerTop = 0;
  if (props.headerTop != null) headerTop = props.headerTop;

  let headHeight = 84;
  if (props.headHeight) headHeight = props.headHeight;
  let style = {
    ...header,
    height: headHeight + 'px',
    top: headerTop + 'px'
  };

  if (props.pos) {
    style = {
      ...style,
      position: ''
    };
  }

  let leftMargin = '20px';

  let iconStyle = {
    width: '30px',
    marginBottom: '-9px'
  };

  let textLength = 0;
  let fontSizeBoldText = 16;
  if (props.data.steps_to_partner)
    textLength += props.data.steps_to_partner.length;
  if (props.data.programs) textLength += props.data.programs.length;
  if (props.data.type_of_oyo_properties)
    textLength += props.data.type_of_oyo_properties.length;
  if (textLength > 55) fontSizeBoldText = 14;
  let oyoLogoStyleFinal = oyoLogoStyle;

  if (props.viewMode == view.MOBILE) {
    oyoLogoStyleFinal = {
      ...oyoLogoStyle,
      height: '24px',
      width: '52px',
      marginLeft: '14px'
    };
    if(hmsSelfOnboardingEnabled())
      oyoLogoStyleFinal = { ...oyoLogoStyleFinal, height: '40px', width: '25vw'}
  }

  if (props.centerHead == true) {
    oyoLogoStyleFinal = {
      ...oyoLogoStyleFinal,
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translateY(-50%) translateX(-50%)',
      marginLeft: '0px'
    };
  }

  if (props.viewMode == view.MOBILE) {
    style = {
      ...style,
      height: '68px'
    };
  }

  if (props.viewMode == view.MOBILE) {
    joinUsBtn_style = {
      ...joinUsBtn_style,
      height: '40px',
      marginRight:0,
      width:'100px'
    };
  }

  let headerTileStyles = {
    padding: '28px 30px 0px 30px',
    fontFamily: 'InterphaseBold',
    textAlign: 'center',
    position: 'relative',
    textTransform: 'capitalize'
  };

  let dropdownParentStyle = {
    position: 'absolute',
    width: '110%',
    left: '0',
    top: headHeight
  };

  let dropdownItem = {
    backgroundColor: 'white',
    textAlign: 'left',
    paddingLeft: '10px',
    paddingTop: '5px',
    height: '24px',
    fontSize: '12px'
  };

  const [showContactDD, setContactDD] = useState(false);
  const [showRegisterDD, setRegisterDD] = useState(false);

  if (headerTop < 0 && (showRegisterDD || showContactDD)) {
    setContactDD(false);
    setRegisterDD(false);
  }

  const oyoSaathiEnabled = props.countryIsoCode == 'in';

  return (
    <React.Fragment>
      {props.data && (
        <div style={style} className={'animate'}>
          <NavLink
            exact
            to="/"
            style={{ textDecoration: 'none', color: '#ffffff' }}
          >
            { hmsSelfOnboardingEnabled() ? <div style={{
              ...oyoLogoStyleFinal, ...props.gs('oyo_360_logo')
            }}><OYO360Logo/></div> : <img
              src={IMAGES.OYO_ICON}
              alt="OYO"
              style={{
                ...oyoLogoStyleFinal
              }}
            />}
          </NavLink>

          {props.showBackButton && (
            <NavLink
              exact
              to="/"
              onClick={e => {
                if (props.formViewMode != formView.STEP_ONE) {
                  e.preventDefault();
                  props.backForm();
                } else {
                  // press back in step 1 event
                }
              }}
              style={{ textDecoration: 'none', color: '#ffffff' }}
            >
              {' '}
              <img
                className={'hover'}
                style={{
                  position: 'absolute',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  left: '20px'
                }}
                src={IMAGES.BACK_BLACK_BUTTON}
              />
            </NavLink>
          )}

          {props.show_right_options &&  <div>
            {props.data.email && props.viewMode == view.DESKTOP && (
              <div
                style={{
                  position: 'absolute',
                  right: '0px',
                  height: '100%',
                  display: 'flex',
                  top: '0px'
                }}
              >
                <a href={'https://www.oyorooms.com/about?oyocorporate='} >
                <div
                  className="hover"
                  style={headerTileStyles}
                >
                  
                  {guc('abt_oyo','About OYO')}
                </div>
                </a>

                {oyoSaathiEnabled && <Link to={getRouteForPage(pages.OYO_SAATHI)}>
                    <div className="hover" style={headerTileStyles}>{guc('oyo_saathi', 'OYO Saathi')}</div>
                </Link>}

                {earningPotentialEnabled() && <>
                    <div
                      onClick={e => {
                        props.changeOyoForm(oyoFormView.checkEarnings);
                        props.handleScrollToForm();
                      }}
                      className="hover"
                      style={headerTileStyles}
                    >
                      {gucl('how_much_can')}{'?'}
                    </div>
                    <ClickAwayListener
                        onClickAway={e => {
                          setRegisterDD(false);
                        }}
                    >
                    <div
                      onClick={e => setRegisterDD(!showRegisterDD)}
                      className="hover"
                      style={headerTileStyles}
                    >
                      { hmsSelfOnboardingEnabled() ? gucl('get_started').toLowerCase() : gucl('get_associated')}
    
                      {showRegisterDD && (
                        <Fade top>
                          <span style={dropdownParentStyle}>
                            <div
                              onClick={e => {
                                props.changeOyoForm(oyoFormView.checkEarnings);
                                props.handleScrollToForm();
                              }}
                              className={'hoverColorGray'}
                              style={dropdownItem}
                            >
                              {gucl('reg_hotel')}
                            </div>
    
                            <div
                              onClick={e => {
                                hmsSelfOnboardingEnabled() ? props.changeOyoForm(oyoFormView.hmsSelfOnboardingHome) : props.changeOyoForm(oyoFormView.homeBasic);
                                props.handleScrollToForm();
                              }}
                              className={'hoverColorGray'}
                              style={dropdownItem}
                            >
                              {gucl('reg_home')}
                            </div>
                          </span>
                        </Fade>
                      )}
                    </div>
                    </ClickAwayListener>
                  </>}
                <ClickAwayListener
                    onClickAway={e => {
                  setContactDD(false);
                }}
                >
                <div
                  onClick={e => {
                    setContactDD(!showContactDD);
                  }}
                  className="hover"
                  style={{ ...headerTileStyles, margin: '0px 10px' }}
                >
                  {guc('contact_us','Contact Us')}
                  {showContactDD && (
                    <Fade top>
                      <span style={dropdownParentStyle}>
                        <a href={props.data.email_us_link}>
                          <div
                            className={'hoverColorGray'}
                            style={dropdownItem}
                          >
                            {(gucl('email_us'))?gucl('email_us'):props.data.email}
                          </div>
                        </a>
                        <a href={props.data.call_us_link}>
                          <div
                            className={'hoverColorGray'}
                            style={dropdownItem}
                          >
                            {(gucl('call_us_at'))?gucl('call_us_at'):"Call@"+props.data.call}
                          </div>
                        </a>
                      </span>
                    </Fade>
                  )}
                </div>
                </ClickAwayListener>
                <div
                  onClick={() => {
                    if(hmsSelfOnboardingEnabled()) props.redirectToHms();
                    else if(selfOnboardingEnabled()){
                      props.changeOyoForm(oyoFormView.loginScreen);
                      props.handleScrollToForm();
                    }else{
                      props.handleScrollToForm();
                    }
                  }}
                  className="hover"
                  style={{
                    ...headerTileStyles,
                    margin: '0',
                    width:'200px',
                    padding:''
                  }}
                >
                  <div className={'hoverColor'} style={{
                    height:'30px',marginTop:'20px',backgroundColor: '#1ab64f',
                    paddingTop:'6px',
                    borderRadius:'4px',
                    marginRight:'5px',
                    color:'white',
                    width:170
                  }}>
                    {((selfOnboardingEnabled() || hmsSelfOnboardingEnabled())?<div style={{display:'flex', justifyContent: 'center', alignItems: 'center'}}><AccountCircleIcon style={{
                      width: '20px',
                      marginBottom: '-2px',
                      marginRight: '5px',
                      height: '20px',
                    }}/>{gucl('login')}</div>:props.data.join_us)}</div>
                </div>
              </div>
            )}
          </div>}

          {props.viewMode == view.MOBILE &&
            props.data.join_us &&
            !props.hide_join_us && (
              <div
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '16px',
                  display:'flex'
                }}
              >
                <NavLink
                  exact
                  to="/form"
                  style={{ textDecoration: 'none', color: '#ffffff' }}
                  onClick={e => {
                    Event(
                      'Partner Page',
                      'Request a call on header clicked',
                      '',
                      ''
                    );
                    props.globalActions.switchSellerBool(false);
                    e.preventDefault();
                    props.handleScrollToForm();
                    hmsSelfOnboardingEnabled() ? props.redirectToHms() : props.changeOyoForm(oyoFormView.otpScreen);
                  }}
                >
                  <button className="hoverColor" style={{...joinUsBtn_style,marginRight:'10px'}}>
                    <span>{(selfOnboardingEnabled() || hmsSelfOnboardingEnabled())?gucl('get_started'):props.data.join_us}</span>
                  </button>
                </NavLink>
                {(selfOnboardingEnabled() || hmsSelfOnboardingEnabled()) && <div>
                  <button className="hoverColor" style={joinUsBtn_style} onClick={e => {
                    if(hmsSelfOnboardingEnabled()) props.redirectToHms();
                    else {
                      props.handleScrollToForm();
                      props.changeOyoForm(oyoFormView.loginScreen);
                    }
                  }}>
                    <span>{gucl('LOGIN')}</span>
                  </button>
                </div>}
              </div>
            )}
        </div>
      )}
    </React.Fragment>
  );
};

export default Header;
